const COMMON = {
  TRAINING: {
    propertyId: '5eb1b659a1bad90e54a1f7e2',
    tawkId: 'default',
  },
  PROD: {
    propertyId: '604bbe60f7ce1827092f8994',
    tawkId: '1f0jtva30',
  },
};

const CHAT = {
  EDLEN: COMMON,
  BJCC: COMMON,
  CAJUNDOME: {}, // no chat for cajundome
  TEST: {}, // no chat in testing environments
};

export default CHAT;
